import app from "./app.js";
import globals from "./globals";
import helpers from "./helpers.js";
import nav from "./nav";
import date from "./date";
import popper from "./popper";

export default {
  install(Vue, options) {

    //add global instance methods and properties to Vue prototype (for use within components)
    Vue.prototype.$app = app; //core application-wide methods
    Vue.prototype.$globals = proxy; //global properties
    Vue.prototype.$helpers = helpers; //helper methods
    Vue.prototype.$nav = nav; //navigation methods
    Vue.prototype.$date = date; //date helper methods
    Vue.prototype.$popper = popper; //popper helper methods

    //add global methods and properties to Vue itself (for use within plugins, vuex etc.)
    Vue.app = app; //core application-wide methods
    Vue.globals = proxy; //global properties
    Vue.helpers = helpers; //helper methods
    Vue.nav = nav; //navigation methods
    Vue.date = date; //date helper methods
    Vue.popper = popper; //date helper methods
  },
};

//allow property style access to any methods contained in the $globals object by immediately invoking the method
const handler = {
  get(object, method) {
    return object[method]();
  },
};

const proxy = new Proxy(globals, handler);
